import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { setupStore } from "app/store";
import { createRouter } from "./createRouter";

const drawerWidth = 240;
const router = createRouter(drawerWidth);

// Vite: Load Error Handling - https://vitejs.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
    console.warn("Vite preload error occured, reloading page...");
    window.location.reload(); // for example, refresh the page
});

// Component
const rootEl = document.getElementById("root");

if (!rootEl) {
    throw new Error("Could not get root element");
}

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <Provider store={setupStore()}>
            <RouterProvider router={router} />
        </Provider>
    </React.StrictMode>,
);
